import { fetchRecipientKeys, type RecipientKeyDirectoryItem } from "../api/e2eeKeys";

function keyFor(recipientUserId: string) {
  return `intimsync_recipient_key:${recipientUserId}`;
}

export function readCachedRecipientKey(recipientUserId: string): RecipientKeyDirectoryItem | null {
  try {
    const raw = window.localStorage.getItem(keyFor(recipientUserId));
    if (!raw) return null;
    const obj = JSON.parse(raw);
    return obj && typeof obj === "object" ? obj as RecipientKeyDirectoryItem : null;
  } catch {
    return null;
  }
}

export function writeCachedRecipientKey(item: RecipientKeyDirectoryItem) {
  window.localStorage.setItem(keyFor(item.recipientUserId), JSON.stringify(item));
}

export async function getRecipientKeys(recipientUserIds: string[]): Promise<RecipientKeyDirectoryItem[]> {
  const uniq = Array.from(new Set(recipientUserIds.map((x) => String(x || "").trim()).filter(Boolean)));
  const cached: RecipientKeyDirectoryItem[] = [];
  const missing: string[] = [];

  for (const id of uniq) {
    const hit = readCachedRecipientKey(id);
    if (hit) cached.push(hit);
    else missing.push(id);
  }

  if (!missing.length) return cached;

  const fetched = await fetchRecipientKeys(missing);
  for (const item of fetched) writeCachedRecipientKey(item);

  return [...cached, ...fetched];
}
